export const langCode = {
    eng: 'eng',
    mar: 'mar',
    hin: 'hin',

}